import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconViewSuperEllipse as Icon } from '@alfa-bank/site-icon-view/super-ellipse';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { Logo as Component } from './component';
import type { IDepsDesktop, TLogoDesktop } from './models';

export const LogoDesktop = createWidget<IDepsDesktop, TLogoDesktop>({
    Icon,
    Text,
})(Component);
